import { ComponentProps } from "react";
import styled from "@emotion/styled";
import { LloydsBankLogo } from "@financial-advisory/ui/illustrations";
import { Icon } from "@unlikelyai-magic/ui/icons";

type ChatAvatarProps = ComponentProps<"div"> & {
  visible?: boolean;
};

export const BotAvatar = styled(({ visible, ...props }: ChatAvatarProps) => (
  <div {...props}>
    <Icon icon={LloydsBankLogo} size="1.25rem" />
  </div>
))`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2rem;
  height: 2rem;
  border-radius: 100%;
  border: 1px solid ${({ theme }) => theme.colors.component.border[1]};
  visibility: ${({ visible }) => (visible ? "visible" : "hidden")};
  background-color: ${({ theme }) => theme.colors.component.background.default};
  padding-top: 0.125rem;
`;
